
define(
	'TavanoTeam.ItemOptionEmptyTemplate.ItemOptionEmptyTemplate'
,   [
		'ProductViews.Option.View',
		'Transaction.Line.Views.Option.View',
		'product_views_option_empty_template.tpl',
		'product_views_option_template.tpl',
		'underscore'
	]
,   function (
		ProductViewsOptionView,
		TransactionLineViewsOptionView,
		product_views_option_empty_template_tpl,
		product_views_option_template_tpl,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			_.extend(ProductViewsOptionView.prototype,{
				initialize: _.wrap(ProductViewsOptionView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					var model = options.model;
					if (model.get('templateSelector') === 'product_views_option_empty_template.tpl') {
						this.template = product_views_option_empty_template_tpl;
					}
					return ret;
				})
			});

			_.extend(TransactionLineViewsOptionView.prototype,{
				initialize: _.wrap(TransactionLineViewsOptionView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					var model = options.model;
					if (model.get('templateSelected') === 'product_views_option_empty_template.tpl') {
						this.template = product_views_option_template_tpl;
					}
					return ret;
				}),

				getContext: function getContext(){
					return {
						unit: this.model 
							&& this.model.attributes 
							&& this.model.attributes.value 
							&& this.model.attributes.value.label 
							? this.model.attributes.value.label.split('-')[2] 
							: ''
					};
				}
			});
		}
	};
});
